import Selectors from '../constants/Selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CesQuestion = ({
  cesStrings: {
    question,
    toWhatExtent
  },
  children
}) => /*#__PURE__*/_jsxs("div", {
  className: "feedback-question",
  children: [/*#__PURE__*/_jsx("div", {
    className: "ces-question",
    children: toWhatExtent
  }), /*#__PURE__*/_jsx("h5", {
    className: "question-text ces",
    "data-selenium-test": Selectors.SURVEY_QUESTION,
    children: question
  }), children]
});
export default CesQuestion;